import { render } from "./ProfileForm.vue?vue&type=template&id=53d7969e"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__